// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"main_snackbarContainer__2Whv4"};